import { render } from "./OurStory.vue?vue&type=template&id=4aa0ca3f"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=4aa0ca3f&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__